import { redirect, useLocation, useSearchParams } from "react-router-dom";
import { LottieLoader } from "../components/loader";
import { useCallback, useEffect } from "react";
import { PolymerAxios } from "../utils/axios";
import config from "../config";
import { Helpers } from "../utils/helper";

const Logout = () => {
  let [searchParam] = useSearchParams();

  const clearData = useCallback(() => {
    Helpers.clearSingpassAuthPersistData();
    Helpers.clearAuthPersistData();
    Helpers.clearPersistData();
  }, [])

  useEffect(() => {
    const singpassToken = searchParam.get("spToken");

    if(singpassToken){
      PolymerAxios('',singpassToken).get(`${config.singpassLogoutUrl}`).then(res=>{
        clearData();
        window.location.href = res.data;
      }).catch((e:any)=>{
        console.error("LOGOUT ERROR- ", e);
        clearData();
        window.location.href = "/transfer";
      })
    }else{
      clearData();
      redirect("/transfer");
    }
  }, []);

  return (
    <div>
      <LottieLoader />
    </div>
  );
};

export default Logout;
